var amountToAdd = 0;
window.onload = function() {

  if (jQuery("a[href*='products/round-up']").closest("tr").length > 0) {
    jQuery("a[href*='products/round-up']").closest("tr").hide();
    jQuery("a[href*='products/round-up']").closest("tr").find("a[href*='/cart/change']")[0].click();
  }
  var cartTotal = jQuery("#ysw_roundup").attr("data-cart-total") * 1;

  var roundUp = round5(cartTotal);
  if (roundUp == cartTotal) {
    roundUp = roundUp + 5;
  }
  amountToAdd = roundUp - cartTotal;
  if (readCookie("yswRoundup") == "1") {
    //check the checkbox
    jQuery("#ysw_roundup_box").prop("checked","checked");
    //console.log('checking box');
  }
  jQuery("#ysw_roundup_box_label").text("Check the box to Round Up for Arroyo Vista");
  //jQuery("#ysw_roundup_box_label").text("Round up your purchase to $" + formatMoney(roundUp) + " to help out Arroyo Vista PTA?");
  jQuery("body").on("click","#ysw_roundup_box", function() {
    if (jQuery("#ysw_roundup_box").prop("checked")) {
      createCookie("yswRoundup", "1", 14);
    } else {
      createCookie("yswRoundup", "0", 14);
    }
  })
  jQuery("body").on("click","#checkout",function() {
    if (jQuery("#ysw_roundup_box").prop("checked")) {
      createCookie("yswRoundup", "1", 14);
      var itemToAdd = 0;
      switch(amountToAdd) {
        case 1:
            itemToAdd = 40048154476634;
            break;
        case 2:
            itemToAdd = 40048154509402;
            break;
        case 3:
            itemToAdd = 40048154542170;
            break;
        case 4:
            itemToAdd = 40048154574938;
            break;
        default:
            itemToAdd = 40048154607706;
      }
      if (itemToAdd > 0) {
        jQuery.ajax('/cart/add.js', {method: "POST", async:false, data:{quantity: 1, id: itemToAdd}});
      }
    } else {
      createCookie("yswRoundup", "0", 14);
    }
  });
};


function formatMoney(number) {
		var n = number, c = 2, d = '.', t = ',', s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
		return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}


function round5(x)
{
    return Math.ceil(x/5)*5;
}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}
